import MuiButton from '@material-ui/core/Button';
import MuiButtonGroup from '@material-ui/core/ButtonGroup';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { HIGHLIGHT, TEXT } from '../Colors';
import { BODY } from '../Fonts';

const useStyles = makeStyles({
    fullWidth: {
        width: '100%',
    },
    fullHeight: {
        height: '100%',
    },
    hidden: {
        display: 'none',
    },
    base: {
        font: BODY,
        fontWeight: 600,
        textTransform: 'none',
        borderRadius: '5px',
        width: '50%'
    },
    on: {
        color: TEXT,
        backgroundColor: HIGHLIGHT,
        margin: '0 !important',
        "&:hover, &:focus": {
            backgroundColor: HIGHLIGHT
        }
    },
    off: {
        color: TEXT,
        borderColor: `${TEXT} !important`,
        "&:hover, &:focus": {
            borderColor: TEXT
        }
    },
    disabled: {
        opacity: 0.5,
        pointerEvents: 'none',
        cursor: 'default'
    }
});

interface SwitchProps {
    labelTrue: string,
    labelFalse: string,
    state: boolean,
    hidden?: boolean,
    disabled?: boolean,
    fullWidth?: boolean,
    fullHeight?: boolean,
    onChange?(state: boolean): void
}

export const Switch: React.FunctionComponent<SwitchProps> = (props) => {
    const classes = useStyles();

    // "stylingClassName" is used for "styled components" extensions. It is hidden from the developer.
    const stylingClassName = (props as any).className ? (props as any).className : '';

    const onChange = (state: boolean) => {
        if (!props.disabled && props.onChange) {
            props.onChange(state);
        }
    }

    const className = `${props.fullWidth ? classes.fullWidth : ''} ${props.fullHeight ? classes.fullHeight : ''} ${props.hidden ? classes.hidden : ''} ${stylingClassName}`;

    return (
        <MuiButtonGroup size="small" className={className}>
            <MuiButton
                onClick={() => onChange(false)}
                variant={!props.state ? "contained" : "outlined"}
                className={`${classes.base} ${!props.state ? classes.on : classes.off} ${props.disabled ? classes.disabled : ''}`}>
                {props.labelFalse}
            </MuiButton>
            <MuiButton
                onClick={() => onChange(true)}
                variant={props.state ? "contained" : "outlined"}
                className={`${classes.base} ${props.state ? classes.on : classes.off} ${props.disabled ? classes.disabled : ''}`}>
                {props.labelTrue}
            </MuiButton>
        </MuiButtonGroup>
    );
}